import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/authentication' },
  { path: 'authentication', loadChildren: ()=> import('./authentication/authentication.module').then(m => m.AuthenticationModule)},
  { path: 'appmain', loadChildren: ()=> import('./appmain/appmain.module').then(m => m.AppmainModule)},
  { path: 'utils', loadChildren: ()=> import('./utils/utils.module').then(m => m.UtilsModule)},
  {path:'online', loadChildren:()=>import('./online/online.module').then(m=>m.OnlineModule)},
  {path:'presignin', loadChildren:()=>import('./presignin/presignin.module').then(m=>m.PresigninModule)}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
